import React, { useState } from 'react'
import ScrollView from 'devextreme-react/scroll-view';

const scrollConfig = {
    showScrollbar: 'always',
    scrollByContent: true,
    scrollByThumb: true,
}

export default ({ children }) => <ScrollView {...scrollConfig}>{children}</ScrollView>